
<div class="m-t-24">
    <div [ngSwitch]="currentStep">
        <div *ngSwitchCase="ADD_BANK_ACCOUNT">
            <div class="hidden-xs">
                <div class="page-title">
                    Enter an account number
                </div>
                <div class="desc opacity-60 font-normal">
                    Enter the 10 Digit Bank account number
                </div>
            </div>
            <form [formGroup]="form" [ngClass]="{'mb-20':!isMobile}" class="bank-details-input animate__animated animate__fadeIn">
                <app-floating-label-input [prefixType]="'grey-bank'" [controlDef]="accountNoControl"
                    label="Enter Account Number" placeHolder="Enter Account Number">
                </app-floating-label-input>
                <div>
                    <div class="float-right mt-[-20px]" nz-row>
                        <div class="pin-gauge">{{form?.value?.accountNo?.length}}/10</div>
                    </div>
                </div>
            </form>
        </div>
    </div>

</div>